import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';
import Wave from 'react-wavify';
import { FaQuoteLeft } from 'react-icons/fa';
// import { EffectCoverflow, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { setTestimonialsData } from '../../redux/actions/actionCreate';
import allTestimonialsData from './TestimonialsData';
import './Testimonials.scss';

const Testimonials = () => {
  const testimonials = useSelector((state) => state.testimonials);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTestimonialsData(allTestimonialsData));
  }, [dispatch]);

  const testimonialsF = 'tESTIMONIALS sECTION';
  return (
    <div className="app__testimonials">
      <h1 className="app__testimonials-title">{testimonialsF}</h1>
      <Swiper
        className="container testimonials-container"
        effect="coverflow"
        pagination={{
          clickable: true,
        }}
        loop
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2,
          slideShadows: true,
        }}
        modules={[EffectCoverflow, Pagination, Autoplay]}
        spaceBetween={-30}
        centeredSlides
        slidesPerView="auto"
      >
        {
          testimonials.map((testimonial) => (
            <SwiperSlide
              className="testimonial"
              key={testimonial.id}
            >
              <div className="testimonial-content">
                <p className="clients-review">
                  <FaQuoteLeft className="quote-icon" />
                  {' '}
                  {testimonial.review}
                </p>
                <div className="client-avatar">
                  <div className="clients-info">
                    <h3 className="clients-name">{testimonial.name}</h3>
                    <p>{testimonial.location}</p>
                  </div>
                  <div>
                    <img src={testimonial.images} alt={testimonial.name} />
                  </div>
                </div>
              </div>
              <Wave
                className="wave-detail"
                fill="#000"
                options={{
                  amplitude: 40,
                  speed: 0.20,
                  points: 5,
                }}
              />
            </SwiperSlide>
          ))
        }
      </Swiper>
    </div>
  );
};

export default Testimonials;
